// Four location backdrops — admin-switchable via /api/settings/location.
export const LOCATIONS = {
  colonnade: {
    key: "colonnade",
    label: "The Colonnade",
    line: "Carved honey sandstone. Dust in golden light.",
    image:
      "https://images.unsplash.com/photo-1758413149235-5f764252dbc9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxjYXJ2ZWQlMjBzYW5kc3RvbmUlMjBwaWxsYXIlMjBnb2xkZW4lMjBsaWdodHxlbnwwfHx8fDE3ODU0MTExNjl8MA&ixlib=rb-4.1.0&q=85",
  },
  courtyard: {
    key: "courtyard",
    label: "The Courtyard",
    line: "Lime-washed plaster. An arched doorway. Terracotta.",
    image:
      "https://images.unsplash.com/photo-1601662528567-526cd06f6582?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHx3YXJtJTIwaXZvcnklMjBwbGFzdGVyJTIwdGV4dHVyZXxlbnwwfHx8fDE3ODU0MTExODF8MA&ixlib=rb-4.1.0&q=85",
  },
  jaali: {
    key: "jaali",
    label: "The Jaali Room",
    line: "Lattice casts geometric light on oak.",
    image:
      "https://images.unsplash.com/photo-1521030283239-29a2fddcbfbd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxnZW9tZXRyaWMlMjBzaGFkb3dzfGVufDB8fHx8MTc4NDI0NDk4M3ww&ixlib=rb-4.1.0&q=85",
  },
  stepwell: {
    key: "stepwell",
    label: "The Stepwell",
    line: "Symmetrical geometry. Long shadows.",
    image:
      "https://images.unsplash.com/photo-1444505465537-42c1e519902b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxzeW1tZXRyaWNhbCUyMHN0ZXB3ZWxsJTIwbG9uZyUyMHNoYWRvd3N8ZW58MHx8fHwxNzg1NDExMTY5fDA&ixlib=rb-4.1.0&q=85",
  },
};
